import { useEffect, useRef } from 'react'
import { FetchModel, GqlModelTypeFragment } from 'src/services'
import { useModelOverviewStore } from './modelOverview.state'

export const useInitializeModelValues = (
  model: FetchModel,
  modelTypes: GqlModelTypeFragment[],
): void => {
  const modelRef = useRef<FetchModel>()
  const modelTypesRef = useRef<GqlModelTypeFragment[]>()

  const { initializeModelValues } = useModelOverviewStore()

  useEffect(() => {
    const shouldUpdate =
      !modelRef.current ||
      modelRef.current.id !== model.id ||
      modelTypesRef.current?.length !== modelTypes.length ||
      model.trainingStart !== modelRef.current.trainingStart ||
      model.trainingEnd !== modelRef.current.trainingEnd ||
      model.trainingPeriod !== modelRef.current.trainingPeriod

    if (shouldUpdate) {
      initializeModelValues(model, modelTypes)
      modelRef.current = model
      modelTypesRef.current = modelTypes
    }
  }, [initializeModelValues, model, modelTypes])
}
